import * as actionTypes from '../Global_action.types';

const initialState = {
  employeeCount: { details: [],role_name: {}, totals: {} },
  logActivities: [],
  upcomingHolidays: [],
  formOverview: {
    months: [],
    generated: [],
    released: [],
    totals: { generated: 0, released: 0, pending: 0 },
  },
  loading: false,
  error: null,
  logs:[],
};

const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    // Employee Count
    case actionTypes.GET_EMPLOYEE_COUNT_REQUEST:
      return { ...state, loading: true, error: null };
    case actionTypes.GET_EMPLOYEE_COUNT_SUCCESS:
      return { ...state, loading: false, employeeCount: action.payload };
    case actionTypes.GET_EMPLOYEE_COUNT_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Log Activities
    case actionTypes.GET_LOG_ACTIVITY_REQUEST:
      return { ...state, loading: true, error: null };
    case actionTypes.GET_LOG_ACTIVITY_SUCCESS:
      return { ...state, loading: false, logActivities: action.payload };
    case actionTypes.GET_LOG_ACTIVITY_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Upcoming Holidays
    case actionTypes.GET_UPCOMING_HOLIDAYS_REQUEST:
      return { ...state, loading: true, error: null };
    case actionTypes.GET_UPCOMING_HOLIDAYS_SUCCESS:
      return { ...state, loading: false, upcomingHolidays: action.payload };
    case actionTypes.GET_UPCOMING_HOLIDAYS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case actionTypes.GET_DASHBOARD_FORM_OVERVIEW_REQUEST:
      return { ...state, loading: true, error: null };
    case actionTypes.GET_DASHBOARD_FORM_OVERVIEW_SUCCESS:
      return { ...state, loading: false, formOverview: action.payload };
    case actionTypes.GET_DASHBOARD_FORM_OVERVIEW_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default dashboardReducer;